import { Navigate, useLocation } from 'react-router-dom'
import { Loader2, ShieldX } from 'lucide-react'
import { useAppAuth } from '@/auth/AuthProvider'

export function RequireAuth({ children }) {
  const { ready, isAuthenticated } = useAppAuth()
  const location = useLocation()
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    )
  }
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />
  }
  return children
}

export function RequireRole({ roles, children }) {
  const { ready, user } = useAppAuth()
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    )
  }
  const role = user?.role
  if (role !== 'admin' && (!roles || !roles.includes(role))) {
    return (
      <div className="max-w-lg mx-auto text-center py-24">
        <ShieldX className="h-12 w-12 text-gray-300 mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-900">No access</h2>
        <p className="text-gray-500 mt-2">
          Your role ({role || 'none'}) can’t open this page.
        </p>
      </div>
    )
  }
  return children
}
